import { render, staticRenderFns } from "./StockEdit.vue?vue&type=template&id=55004c21&"
import script from "./StockEdit.vue?vue&type=script&lang=js&"
export * from "./StockEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "StockEdit.vue"
export default component.exports